import { createRef, useEffect } from 'react'
import { ParkingLayoutProps } from './SingleParkingMap'

export const ParkingAB = (props: ParkingLayoutProps) => {
  const ref = createRef<any>()

  useEffect(() => {
    props.available.forEach(available => {
      const spot = ref.current && ref.current.parentNode.getElementById(`space_${available}`)
      if (!spot) {
        return
      }
      spot.classList.add('spot-available')
    })
  }, [ref, props.available])

  return (
    <svg
      width='100%'
      height='100%'
      viewBox='0 0 375 768'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'>
      <desc>Created with Sketch.</desc>
      <g id='parkingE' stroke='none' strokeWidth='1' fill='none' ref={ref} fillRule='evenodd'>
        <g id='legend' transform='translate(13.000000, 15.000000)'>
          <rect
            id='Rectangle'
            stroke='#353535'
            strokeWidth='2'
            fill='#FFFFFF'
            x='0'
            y='0'
            width='348'
            height='737'
          />
          <path
            d='M19,363 L195.900414,361.380746 L195.900414,364 C195.900414,374.49341 187.393824,383 176.900414,383 L56.6711308,383 L56.6711308,383 L56.6711308,424 L175.02333,423.138184 C185.507543,423.06184 194.072049,431.492376 194.160996,441.97649 L195.900414,647 L195.900414,647 L153.021376,646.458101 L55.6600313,637.666065 L19,638.216725 L19,363 Z'
            id='Path-4'
            stroke='#E6E6E6'
            fill='#F8F8F8'
          />
          <polygon
            id='Path-2-Copy-2'
            fill='#D8D8D8'
            transform='translate(225.532894, 569.216725) rotate(-180.000000) translate(-225.532894, -569.216725) '
            points='224.69178 548 226.436352 548 226.436352 574.45414 229.065788 574.45414 225.664114 590.433451 222 574.483558 224.69178 574.45414'
          />
          <polygon
            id='Path-2'
            fill='#D8D8D8'
            points='208.69178 549 210.436352 549 210.436352 575.45414 213.065788 575.45414 209.664114 591.433451 206 575.483558 208.69178 575.45414'
          />
          <polygon
            id='Path-2-Copy-2'
            fill='#D8D8D8'
            transform='translate(225.532894, 169.216725) rotate(-180.000000) translate(-225.532894, -169.216725) '
            points='224.69178 148 226.436352 148 226.436352 174.45414 229.065788 174.45414 225.664114 190.433451 222 174.483558 224.69178 174.45414'
          />
          <polygon
            id='Path-2-Copy-4'
            fill='#D8D8D8'
            transform='translate(103.032894, 396.716725) rotate(-270.000000) translate(-103.032894, -396.716725) '
            points='102.19178 375.5 103.936352 375.5 103.936352 401.95414 106.565788 401.95414 103.164114 417.933451 99.5 401.983558 102.19178 401.95414'
          />
          <polygon
            id='Path-2'
            fill='#D8D8D8'
            points='208.69178 149 210.436352 149 210.436352 175.45414 213.065788 175.45414 209.664114 191.433451 206 175.483558 208.69178 175.45414'
          />
          <polygon
            id='Path-2-Copy'
            fill='#D8D8D8'
            transform='translate(104.032894, 412.716725) rotate(-90.000000) translate(-104.032894, -412.716725) '
            points='103.19178 391.5 104.936352 391.5 104.936352 417.95414 107.565788 417.95414 104.164114 433.933451 100.5 417.983558 103.19178 417.95414'
          />
          <path
            d='M39,69 L174,69 C185.045695,69 194,77.954305 194,89 L194,341 L194,341 L125.358163,341 L54.8398559,280.87953 L19,281.34777 L19,89 C19,77.954305 27.954305,69 39,69 Z'
            id='Rectangle'
            stroke='#E6E6E6'
            fill='#F8F8F8'
          />
          <polygon
            id='Path-2-Copy-3'
            fill='#D8D8D8'
            transform='translate(101.532894, 47.216725) rotate(-270.000000) translate(-101.532894, -47.216725) '
            points='100.69178 26 102.436352 26 102.436352 52.4541405 105.065788 52.4541405 101.664114 68.433451 98 52.4835579 100.69178 52.4541405'
          />
          <polygon
            id='Path-3'
            stroke='#767676'
            fill='#4E4E4E'
            points='46.012691 102 154 102 154 363 44 364 44 311 54.1585352 310.982162 54.2083035 280.800056 45.291197 280.816402'
          />
          <text
            id='B'
            fontFamily='LucidaGrande, Lucida Grande'
            fontSize='22'
            fontWeight='normal'
            fill='#FFFFFF'>
            <tspan x='93.6728516' y='233'>
              B
            </tspan>
          </text>
          <g
            id='noun_Car_2855623-Copy'
            transform='translate(226.138889, 694.000000) rotate(-360.000000) translate(-226.138889, -694.000000) translate(220.000000, 681.000000)'
            fill='#D8D8D8'>
            <path
              d='M12.2524043,8.49090935 C12.2078167,8.11480332 11.5641689,7.9608114 11.2844866,7.91141547 C11.2329229,5.95764438 11.1115558,3.18669949 10.8287468,1.96077119 C10.3686385,-0.033732172 6.19573431,3.62240035e-05 6.19573431,3.62240035e-05 L6.08204182,3.62240035e-05 C6.08204182,3.62240035e-05 1.90913976,-0.033732172 1.44902827,1.96077119 C1.16622037,3.18669921 1.04485322,5.95764438 0.993289488,7.91141547 C0.713606183,7.96081571 0.0699637837,8.11480332 0.0253713073,8.49090935 C-0.0317141342,8.97243427 0.0253713073,8.85498813 0.0253713073,8.85498813 L0.977690523,8.56928519 C0.959261452,9.44652324 0.956054744,10.0402058 0.956054744,10.0402058 L0.956054744,19.7760948 C0.956054744,19.7760948 1.12037927,21.6691872 1.28470377,23.3256363 C1.4490283,24.9820897 1.90913979,25.6581937 4.14395234,25.8948262 C6.3787638,26.1314673 8.13382709,25.8948262 8.13382709,25.8948262 C10.3686385,25.6581937 10.8287468,24.9820897 10.9930724,23.3256363 C11.1573958,21.6691872 11.3217214,19.7760948 11.3217214,19.7760948 L11.3217214,10.0402058 C11.3217214,10.0402058 11.3185158,9.44652324 11.3000856,8.56928519 L12.2524043,8.85498813 C12.2524043,8.85498813 12.3094947,8.97243427 12.2524043,8.49090935 Z M2.52094697,5.65761848 C3.67662344,4.72240216 6.08336209,4.69447413 6.08336209,4.69447413 L6.19441568,4.69447413 C6.19441568,4.69447413 8.60115433,4.72240213 9.75682974,5.65761848 C10.9125052,6.59283482 10.3667721,7.77051399 10.1741549,8.74036378 C9.98154626,9.71021631 9.82103693,10.4722439 9.82103693,10.4722439 C9.82103693,10.4722439 8.21776574,9.95268026 6.19441568,9.95268026 L6.08336209,9.95268026 C4.06000884,9.95268026 2.45674514,10.4722439 2.45674514,10.4722439 C2.45674514,10.4722439 2.29623472,9.71021631 2.10361752,8.74036378 C1.9110089,7.77051399 1.36527156,6.59283427 2.52094697,5.65761848 Z M1.0990037,8.30558021 L1.25839015,8.30558021 C1.47091033,9.48115908 1.73655638,10.789467 1.78968321,12.5971362 C1.79725349,12.8547229 1.80240276,13.1089569 1.80555556,13.3611287 C1.43115802,13.1808199 1.21020573,12.9718027 1.08669192,12.8179741 C1.07461161,10.2203493 1.0990037,8.30558021 1.0990037,8.30558021 Z M1.95116394,18.8666478 C1.75416915,20.8593688 1.53926307,20.0665619 1.53926307,20.0665619 C1.485548,18.1742064 1.45771437,16.2154964 1.44444444,14.4444605 C1.64397408,14.5624017 1.97087109,14.6454235 2.16666667,14.6876579 C2.15877424,16.0895252 2.09147054,17.44738 1.95116394,18.8666478 Z M5.83323625,23.4722257 L5.72231931,23.4722257 C2.50124563,23.4722257 1.80555556,22.8636165 1.80555556,22.8636165 C1.80555556,22.8636165 1.80555556,22.4781629 1.90130668,21.7883977 C1.99706205,21.0986405 2.22175733,19.8611197 2.22175733,19.8611197 C4.0322295,20.1857197 5.70554602,20.1829207 5.70554602,20.1829207 L5.76457725,20.1829207 C5.76457725,20.1829207 7.52332927,20.1857197 9.33379929,19.8611197 C9.33379929,19.8611197 9.5584935,21.0986405 9.65424782,21.7883977 C9.75,22.4781629 9.75,22.8636165 9.75,22.8636165 C9.75,22.8636165 9.05430674,23.4722257 5.83323625,23.4722257 Z M10.7385113,20.0665619 C10.7385113,20.0665619 10.5236084,20.8593688 10.3266117,18.8666478 C10.1863058,17.44738 10.1190075,16.0895252 10.1111111,14.6876579 C10.3069086,14.6454235 10.6338048,14.5623983 10.8333333,14.4444605 C10.8200625,16.2154965 10.7922261,18.1742064 10.7385113,20.0665619 Z M11.1910855,12.8179776 C11.0675703,12.971805 10.8466151,13.1808231 10.4722222,13.3611287 C10.475378,13.1089601 10.4805272,12.8547193 10.4880975,12.5971328 C10.541229,10.7894651 10.8068728,9.48115815 11.0193851,8.30558021 L11.1787738,8.30558021 C11.1787738,8.30558021 11.2031667,10.2203508 11.1910855,12.8179776 Z'
              id='Shape'
            />
          </g>
          <polygon
            id='Path-3-Copy'
            stroke='#101010'
            fill='#4E4E4E'
            points='47.012691 460 155 460 155 647.4558 147.113274 647.771499 147.430576 664.475988 155 664.751413 155 721 45 722 45 669 55.2176219 669.380625 55.2625987 638.239995 48.291197 637.816402'
          />
          <text
            id='A'
            fontFamily='LucidaGrande, Lucida Grande'
            fontSize='22'
            fontWeight='normal'
            fill='#FFFFFF'>
            <tspan x='94.9106445' y='594'>
              A
            </tspan>
          </text>
          <polygon
            id='Path-5'
            stroke='#E6E6E6'
            fill='#F8F8F8'
            points='242 654 242 686 308.935382 686 307.909883 2 241 2 241 31.7576845 281.025972 31.9857407 282 654'
          />
          <path
            d='M242,704 L309,704 C309,716.702549 298.702549,727 286,727 L265,727 C252.297451,727 242,716.702549 242,704 L242,704 L242,704 Z'
            id='Rectangle'
            stroke='#E6E6E6'
            fill='#F8F8F8'
          />
          <circle id='Oval' stroke='#9DD135' cx='294' cy='616.75' r='9' />
          <circle id='Oval' stroke='#9DD135' cx='294' cy='569.5' r='9' />
          <circle id='Oval' stroke='#9DD135' cx='294' cy='522.25' r='9' />
          <circle id='Oval' stroke='#9DD135' cx='294' cy='475' r='9' />
          <circle id='Oval' stroke='#9DD135' cx='294' cy='427.75' r='9' />
          <circle id='Oval' stroke='#9DD135' cx='294' cy='380.5' r='9' />
          <circle id='Oval' stroke='#9DD135' cx='294' cy='333.25' r='9' />
          <circle id='Oval' stroke='#9DD135' cx='294' cy='286' r='9' />
          <circle id='Oval' stroke='#9DD135' cx='294' cy='238.75' r='9' />
          <circle id='Oval' stroke='#9DD135' cx='294' cy='191.5' r='9' />
          <circle id='Oval' stroke='#9DD135' cx='294' cy='144.25' r='9' />
          <circle id='Oval' stroke='#9DD135' cx='294' cy='97' r='9' />
          <circle id='Oval' stroke='#9DD135' cx='276' cy='670' r='9' />
          <circle id='Oval' stroke='#9DD135' cx='277' cy='715' r='9' />
          <rect
            id='Rectangle'
            stroke='#E6E6E6'
            fill='#F8F8F8'
            x='161'
            y='669'
            width='34'
            height='34'
          />
          <rect
            id='Rectangle'
            stroke='#E6E6E6'
            fill='#F8F8F8'
            x='2'
            y='2'
            width='192'
            height='22'
          />
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_36'
          transform='translate(167.000000, 120.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.85188539e-14 38 -1.2490009e-14 38 15 1 15'
          />
          <text
            id='36'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='13.4384766' y='10'>
              36
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_40'
          transform='translate(167.000000, 188.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.85188539e-14 38 -1.2490009e-14 38 15 1 15'
          />
          <text
            id='40'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='13.4384766' y='10'>
              40
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_37'
          transform='translate(167.000000, 137.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.85188539e-14 38 -1.2490009e-14 38 15 1 15'
          />
          <text
            id='37'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='13.4384766' y='10'>
              37
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_41'
          transform='translate(167.000000, 205.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.85188539e-14 38 -1.2490009e-14 38 15 1 15'
          />
          <text
            id='41'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='13.4384766' y='10'>
              41
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_38'
          transform='translate(167.000000, 154.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.85188539e-14 38 -1.2490009e-14 38 15 1 15'
          />
          <text
            id='38'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='13.4384766' y='10'>
              38
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_42'
          transform='translate(167.000000, 222.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.85188539e-14 38 -1.2490009e-14 38 15 1 15'
          />
          <text
            id='42'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='13.4384766' y='10'>
              42
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_39'
          transform='translate(167.000000, 171.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.85188539e-14 38 -1.2490009e-14 38 15 1 15'
          />
          <text
            id='39'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='13.4384766' y='10'>
              39
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_43'
          transform='translate(167.000000, 239.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.85188539e-14 38 -1.2490009e-14 38 15 1 15'
          />
          <text
            id='43'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='13.4384766' y='10'>
              43
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_44'
          transform='translate(167.000000, 256.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.85188539e-14 38 -1.2490009e-14 38 15 1 15'
          />
          <text
            id='44'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='13.4384766' y='10'>
              44
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_45'
          transform='translate(167.000000, 273.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.85188539e-14 38 -1.2490009e-14 38 15 1 15'
          />
          <text
            id='45'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='13.4384766' y='10'>
              45
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_46'
          transform='translate(167.000000, 290.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.85188539e-14 38 -1.2490009e-14 38 15 1 15'
          />
          <text
            id='46'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='13.4384766' y='10'>
              46
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_47'
          transform='translate(167.000000, 307.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.85188539e-14 38 -1.2490009e-14 38 15 1 15'
          />
          <text
            id='47'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='13.4384766' y='10'>
              47
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_52'
          transform='translate(168.000000, 544.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.85188539e-14 38 -1.2490009e-14 38 15 1 15'
          />
          <text
            id='52'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='13.4384766' y='10'>
              52
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_48'
          transform='translate(168.000000, 476.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.85188539e-14 38 -1.2490009e-14 38 15 1 15'
          />
          <text
            id='48'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='13.4384766' y='10'>
              48
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_54'
          transform='translate(168.000000, 578.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.85188539e-14 38 -1.2490009e-14 38 15 1 15'
          />
          <text
            id='54'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='13.4384766' y='10'>
              54
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_53'
          transform='translate(168.000000, 561.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.85188539e-14 38 -1.2490009e-14 38 15 1 15'
          />
          <text
            id='53'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='13.4384766' y='10'>
              53
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_49'
          transform='translate(168.000000, 493.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.85188539e-14 38 -1.2490009e-14 38 15 1 15'
          />
          <text
            id='49'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='13.4384766' y='10'>
              49
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_55'
          transform='translate(168.000000, 595.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.85188539e-14 38 -1.2490009e-14 38 15 1 15'
          />
          <text
            id='55'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='13.4384766' y='10'>
              55
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_50'
          transform='translate(168.000000, 510.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.85188539e-14 38 -1.2490009e-14 38 15 1 15'
          />
          <text
            id='50'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='13.4384766' y='10'>
              50
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_56'
          transform='translate(168.000000, 612.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.85188539e-14 38 -1.2490009e-14 38 15 1 15'
          />
          <text
            id='56'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='13.4384766' y='10'>
              56
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_51'
          transform='translate(168.000000, 527.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.85188539e-14 38 -1.2490009e-14 38 15 1 15'
          />
          <text
            id='51'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='13.4384766' y='10'>
              51
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_57'
          transform='translate(168.000000, 629.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.85188539e-14 38 -1.2490009e-14 38 15 1 15'
          />
          <text
            id='57'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='13.4384766' y='10'>
              57
            </tspan>
          </text>
        </g>
      </g>
    </svg>
  )
}
